var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 43,
    viewBox: "0 0 140 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.376 34.9395H101.876V35.4395V40.4091H11.6425L0.5 29.0169V0.5H127.448L138.591 11.8922V40.4091H124.031L121.118 35.1956L120.975 34.9395H120.682H102.376Z",
    stroke: "url(#paint0_linear_10706_18882)",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0488 25.9238L51.0879 26.4414L51.127 25.9238L54.2324 14.9961H55.5312L51.4102 29H50.7461L46.6445 14.9961H47.9531L51.0488 25.9238ZM57.3281 29V14.9961H58.5879V29H57.3281ZM61.8008 29V14.9961H69.6816V16.1973H63.0605V21.4023H68.4219V22.6035H63.0605V27.7988H69.6816V29H61.8008ZM81.4492 29H80.7949L78.0703 18.4629L78.0312 17.916L77.9727 18.4629L75.2676 29H74.6133L70.8926 14.9961H72.1523L74.8965 25.6406L74.9355 26.1582L74.9746 25.6406L77.6699 14.9961H78.373L81.0684 25.6406L81.1074 26.1582L81.1562 25.6406L83.8906 14.9961H85.1504L81.4492 29Z",
    fill: "#4BF497"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 38.259L107.714 40.9867L109.528 39.1795V42.4149H110.422V37L107.714 39.7074L105 37V38.259Z",
    fill: "url(#paint1_linear_10706_18882)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.737 42.3404V42.4149H114.345V41.5079H111.638L110.737 42.3404ZM110.737 37L111.638 37.907H114.345V37H110.737ZM110.737 39.2607V40.1609H111.638H114.345V39.2607H111.638H110.737Z",
    fill: "url(#paint2_linear_10706_18882)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.041 37V37.907V42.4149H115.948V37.907H117.748V37H115.041Z",
    fill: "url(#paint3_linear_10706_18882)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.669 40.6144L119.468 39.0238L120.26 40.6144H121.275L119.468 37L116.76 42.4149H117.762L118.222 41.5079L118.669 40.6144ZM121.722 41.5147H120.72L121.167 42.4149H122.175L121.722 41.5147Z",
    fill: "url(#paint4_linear_10706_18882)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10706_18882",
    x1: 0,
    y1: 32.7273,
    x2: 139.091,
    y2: 32.7273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10706_18882",
    x1: 105,
    y1: 41.3319,
    x2: 122.175,
    y2: 41.3319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10706_18882",
    x1: 105,
    y1: 41.3319,
    x2: 122.175,
    y2: 41.3319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10706_18882",
    x1: 105,
    y1: 41.3319,
    x2: 122.175,
    y2: 41.3319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10706_18882",
    x1: 105,
    y1: 41.3319,
    x2: 122.175,
    y2: 41.3319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnView);
export default __webpack_public_path__ + "static/media/btn-view.132f1a54a597e4fa9039a3d8dbcbb1ae.svg";
export { ForwardRef as ReactComponent };